import { Stack } from "expo-router";
import { useEffect } from "react";

import { DocumentHead } from "@/components/ui/DocumentHead";
import { registerPublicShowServiceWorker } from "@/lib/shows/publicShowServiceWorker";
import { palette } from "@/theme/palette";

export default function PublicShowsLayout() {
  useEffect(() => {
    void registerPublicShowServiceWorker().catch(() => undefined);
  }, []);

  return (
    <>
      <DocumentHead>
        <link rel="manifest" href="/manifest.webmanifest" />
        <meta
          name="theme-color"
          content={palette.light.surface}
          media="(prefers-color-scheme: light)"
        />
        <meta name="theme-color" content={palette.dark.bg} media="(prefers-color-scheme: dark)" />
      </DocumentHead>
      <Stack screenOptions={{ headerShown: false }} />
    </>
  );
}
